/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./menu-item.component";
var styles_UIMenuItemComponent = [];
var RenderType_UIMenuItemComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_UIMenuItemComponent, data: {} });
export { RenderType_UIMenuItemComponent as RenderType_UIMenuItemComponent };
export function View_UIMenuItemComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_UIMenuItemComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ui-menu-item", [], null, [[null, "click"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1).selectItem() !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_UIMenuItemComponent_0, RenderType_UIMenuItemComponent)), i0.ɵdid(1, 49152, null, 0, i1.UIMenuItemComponent, [], null, null)], null, null); }
var UIMenuItemComponentNgFactory = i0.ɵccf("ui-menu-item", i1.UIMenuItemComponent, View_UIMenuItemComponent_Host_0, { disabled: "disabled" }, { onSelectItem: "onSelectItem" }, ["*"]);
export { UIMenuItemComponentNgFactory as UIMenuItemComponentNgFactory };
